import styled from 'styled-components';
import { BREAKPOINTS } from "../../../../../app/appConstants.js";

export const BonusActivePanelStyled = styled.div`
    margin-top: 8px;
    padding: 8px;
    width: 100%;
    display: flex;
    flex-direction: column;
    background: linear-gradient(94.58deg, rgba(20, 198, 121, 0.2) 0%, rgba(123, 97, 255, 0.2) 100%);
    border-radius: 4px;
`;

export const BonusActivePanelFlatStyled = styled(BonusActivePanelStyled)`
    flex-direction: row;
    align-items: center;
    width: 100%;
    min-width: 97%;
    padding: 16px 8px 16px 16px;
    
    &:not(:first-child) {
        margin-left: 8px;
    }

    @media (max-width: 350px) {
        padding: 16px 8px;
    }
`;

export const BonusActivePanelTitleWageredStyled = styled.div`
    font-size: 12px;
    color: var(--color-white);
    font-weight: 600;
`;

export const BonusActivePanelTitleCanceledStyled = styled.div`
    font-size: 10px;
    color: var(--text-color-secondary);
`;

export const BonusActivePanelLotsWagerContentStyled = styled.div`
    flex: 1 1 auto;
    display: flex;
    flex-direction: ${({ flat }) => flat ? 'row' : 'column'};
    ${({ flat }) => !!flat && 'margin: 0 8px'};
    
    @media (max-width: 350px) {
        margin: 0 0 0 4px;
    } 
`;

export const BonusActivePanelAmountStyled = styled.div`
    color: var(--color-white);
    font-size: 24px;
    font-weight: 700;

    @media (max-width: ${BREAKPOINTS.small}px) {
        font-size: 20px;
    }
`;

export const BonusActivePanelOnEquityBadgeWrapperStyled = styled.div`
    margin-bottom: 12px;
    ${({flat}) => !!flat && 'margin-left: 8px'};
    @media (max-width: ${BREAKPOINTS.small}px) {
        margin-bottom: 0;
    }
    @media (max-width: 350px) {
        margin-left: 4px;
    }
`;

export const BonusActivePanelTitleStyled = styled.div`
    padding-left: ${({flat}) => !!flat ? '16px' : '8px'};
    display: flex;
    align-items: center;
    color: var(--color-secondary-active);
    font-size: ${({flat}) => !!flat ? '14px' : '10px'};
`;

export const BonusActivePanelWrapperStyled = styled.div`
    ${({flat}) => !!flat && 'background-color: #1B1C2D'};
    ${({flat}) => !!flat && 'padding: 16px 0 8px'};
`;

export const BonusActivePanelListContainerStyled = styled.div`
    display: flex;
    flex-direction: ${({flat}) => !!flat ? 'row' : 'column'};
    overflow-x: auto;
    ${({flat}) => !!flat && 'padding: 0 8px 8px'};
`;
